import React, { useState, useRef, useEffect } from 'react';

/**
 * StaffSelector - "Selling as" dropdown matching diary staff picker style.
 * Search input + clean text list, selected item has dark filled row with checkmark.
 */
const StaffSelector = ({ staffList, selectedStaff, onSelect }) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  const getStaffName = (s) => s.name || `${s.firstName || ''} ${s.lastName || ''}`.trim();
  const selectedName = selectedStaff?.staffName || 'Select staff';

  const filtered = search
    ? staffList.filter(s => getStaffName(s).toLowerCase().includes(search.toLowerCase()))
    : staffList;

  const handleSelect = (s) => {
    onSelect({
      staffId: s._id || s.id,
      staffName: getStaffName(s),
    });
    setOpen(false);
    setSearch('');
  };

  return (
    <div className="pos-staff-bar" ref={ref}>
      <span className="pos-staff-bar-label">Selling as</span>
      <button className="pos-staff-selected" onClick={() => setOpen(!open)}>
        <span className="pos-staff-selected-name">{selectedName}</span>
        <svg className={`pos-staff-chevron ${open ? 'pos-staff-chevron--open' : ''}`} width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>

      {open && (
        <div className="pos-staff-dropdown">
          <div className="pos-staff-dropdown-search">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#8e8e93" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <input
              type="text"
              placeholder="Search staff..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              autoFocus
            />
          </div>
          <div className="pos-staff-dropdown-list">
            {filtered.map(s => {
              const sid = s._id || s.id;
              const name = getStaffName(s);
              const isActive = selectedStaff?.staffId === sid;
              return (
                <button
                  key={sid}
                  className={`pos-staff-dropdown-item ${isActive ? 'pos-staff-dropdown-item--active' : ''}`}
                  onClick={() => handleSelect(s)}
                >
                  <span>{name}</span>
                  {isActive && (
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path d="M2 7.5L5.5 11L12 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )}
                </button>
              );
            })}
            {filtered.length === 0 && (
              <div className="pos-staff-dropdown-empty">No staff found</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default StaffSelector;
